// core/i18n/index.ts - Configuración principal de i18next para Westeer
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones - Español
import commonES from './locales/es/common.json';
import authES from './locales/es/auth.json';
import dashboardES from './locales/es/dashboard.json';
import adminES from './locales/es/admin.json';
import projectsES from './locales/es/projects.json';

// Importar traducciones - Inglés
import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import dashboardEN from './locales/en/dashboard.json';
import adminEN from './locales/en/admin.json';
import projectsEN from './locales/en/projects.json';

// Importar traducciones - Portugués
import commonPT from './locales/pt/common.json';
import authPT from './locales/pt/auth.json';
import dashboardPT from './locales/pt/dashboard.json';
import adminPT from './locales/pt/admin.json';
import projectsPT from './locales/pt/projects.json';

// Importar traducciones - Francés
import commonFR from './locales/fr/common.json';
import authFR from './locales/fr/auth.json';
import dashboardFR from './locales/fr/dashboard.json';
import adminFR from './locales/fr/admin.json';
import projectsFR from './locales/fr/projects.json';

// Configuración de recursos
const resources = {
  es: {
    common: commonES,
    auth: authES,
    dashboard: dashboardES,
    admin: adminES,
    projects: projectsES,
  },
  en: {
    common: commonEN,
    auth: authEN,
    dashboard: dashboardEN,
    admin: adminEN,
    projects: projectsEN,
  },
  pt: {
    common: commonPT,
    auth: authPT,
    dashboard: dashboardPT,
    admin: adminPT,
    projects: projectsPT,
  },
  fr: {
    common: commonFR,
    auth: authFR,
    dashboard: dashboardFR,
    admin: adminFR,
    projects: projectsFR,
  },
};

// Migrate legacy language preference before i18n detector reads from localStorage
const _legacyLang = localStorage.getItem('westeer_language');
if (_legacyLang && !localStorage.getItem('wayline_language')) {
  localStorage.setItem('wayline_language', _legacyLang);
  localStorage.removeItem('westeer_language');
}

i18n
  .use(LanguageDetector) // Detecta idioma del navegador
  .use(initReactI18next) // Pasa i18n a react-i18next
  .init({
    resources,
    fallbackLng: 'es', // 🇪🇸 Español como idioma por defecto
    defaultNS: 'common', // Namespace por defecto
    ns: ['common', 'auth', 'dashboard', 'admin', 'projects'], // Namespaces disponibles
    lng: 'es', // 🇪🇸 Forzar español como idioma inicial

    detection: {
      // Orden de detección de idioma
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], // Guardar preferencia en localStorage
      lookupLocalStorage: 'wayline_language',

      // Convertir códigos de idioma del navegador
      convertDetectedLanguage: (lng: string) => {
        const langCode = lng.split('-')[0].toLowerCase();
        const supportedLangs = ['es', 'en', 'pt', 'fr'];
        return supportedLangs.includes(langCode) ? langCode : 'es';
      },
    },

    interpolation: {
      escapeValue: false, // React ya escapa por defecto
      formatSeparator: ',',
    },

    react: {
      useSuspense: true, // Usar Suspense para carga lazy
      bindI18n: 'languageChanged loaded',
    },

    // Debug en desarrollo
    debug: import.meta.env.DEV,
  });

export default i18n;
